import { render, staticRenderFns } from "./DetailTransaction.vue?vue&type=template&id=0d78b8d8&scoped=true&"
import script from "./DetailTransaction.vue?vue&type=script&lang=js&"
export * from "./DetailTransaction.vue?vue&type=script&lang=js&"
import style0 from "./DetailTransaction.vue?vue&type=style&index=0&id=0d78b8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d78b8d8",
  null
  
)

export default component.exports